import axios from "axios";
const API_URL = "/api/common";

export const getClasses = () => axios.get(`${API_URL}/classes`);
export const getTerms = () => axios.get(`${API_URL}/terms`);
export const getDivisions = () => axios.get(`${API_URL}/divisions`);
export const getSubjects = () => axios.get(`${API_URL}/subjects`);
export const getChaptersList = () => axios.get(`${API_URL}/subjects`);